export const signup = (user, autoConfirm = false) => (
  $.ajax({
    type: "POST",
    url: "/",
    data: { user: user, autoConfirm }
  })
);

export const fetchSessionState = () => $.ajax({
  type: 'GET', url: '/session_state', dataType: 'json', cache: false
}).then(state => {
  if (!state.csrf_token) throw new Error('Unable to refresh sign-in session');
  $('meta[name="csrf-token"]').attr('content', state.csrf_token);
  return state;
});

export const login = (user) => fetchSessionState().then(() => (
  $.ajax({
    type: "POST",
    url: "/sign_in",
    data: {user: {...user, remember_me: user.remember_me === false ? 0 : 1}}
  })
));

export const loginErrorMessages = response => {
  let data = response?.responseJSON;
  if (!data && response?.responseText) {
    try { data = JSON.parse(response.responseText); } catch (_) { /* Never display an HTML error page in the form. */ }
  }
  if (Array.isArray(data)) return data.filter(message => typeof message === 'string');
  if (typeof data?.error === 'string') return [data.error];
  return [response?.status === 0 ? 'Connection interrupted. Please try signing in again.' : 'We couldn’t sign you in. Please try again.'];
};

export const logout = () => (
  $.ajax({
    type: "DELETE",
    url: "/sign_out",
  })
);

export const submitForgotPassword = (user) => (
  $.ajax({
    type: "POST",
    url: "/password",
    data: { user: user }
  })
)

export const submitUpdatedPassword = (user) => (
  $.ajax({
    type: "PUT",
    url: "/password",
    data: { user: user }
  })
)

export const submitConfirmationResend = (user) => (
  $.ajax({
    type: "POST",
    url: "/confirmation",
    data: { user: user }
  })
)

export const agreeToTerms = () => (
  $.ajax({
    type: "POST",
    url: "/agree_to_terms"
  })
);

export const markGoogleReviewShown = () => (
  $.ajax({
    type: "POST",
    url: "/google_review_shown"
  })
);

export const fetchConfirmation = (user) => (
  $.ajax({
    type: "GET",
    url: "/confirmation",
    data: user
  })
)

export const fetchCurrentUser = (user_id) => (
  $.ajax({
    type: "GET",
    url: "/fetch_user",
    data: {id: user_id, user_id: user_id}
  })
)

export const fetchNotificationCount = (user_id) => (
  $.ajax({
    type: "GET",
    url: "/fetch_notification_count",
    data: { id: user_id, user_id: user_id }
  })
)
